import { render, staticRenderFns } from "./Wp_jd_course.vue?vue&type=template&id=7b033532&scoped=true&"
import script from "./Wp_jd_course.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b033532",
  null
  
)

export default component.exports